'use client';
import { Button, Typography } from 'components';
import { PlusIcon } from 'lib/svgs/Icons';
import Link from 'next/link';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { cn } from 'utils/cn';

interface ICardIntegration {
  href: string;
  title: string;
  label: string;
  icon: ReactNode;
}

const CardIntegration: FC<PropsWithChildren<ICardIntegration>> = ({
  title,
  href,
  label,
  icon,
  children
}) => {
  return (
    <div
      className={cn(
        'relative flex flex-col items-center justify-between !rounded-[8px] bg-white p-4 shadow-custom',
        'min-h-[216px] w-[205px]'
      )}
    >
      <div className="flex flex-col items-center justify-end">
        <span className="flex h-[64px] w-[64px] items-center justify-center">{icon}</span>
        <Typography variant="medium2" className={cn('my-0 !mt-1 text-tertiary-100')}>
          {title}
        </Typography>
      </div>
      {children ? (
        children
      ) : (
        <Link href={href} className="mt-6 w-full">
          <Button
            colorIcon="white"
            color="secondary"
            size="small"
            className="w-full"
            startAdornment={<PlusIcon className="scale-125" />}
            label={label}
          />
        </Link>
      )}
    </div>
  );
};

export default CardIntegration;
